import React from 'react';
import jump from 'jump.js';
import { changeBanksFields } from '@utils/banks-selectors';
import BankTransferForm from '@ui-components/bank-transfer/form/index';
import BankTransferSuccess from '@ui-components/bank-transfer/success/index';
import Dialog from '@ui-components/dialog/index';
import formatAmount from '@utils/amount-formatter';
import random from '@utils/random';
import removeAccents from '@utils/remove-accents';
import { createBankTransfer } from '@services/bank-transfer';
import { API_ERRORS, BANKS, DLOCALBANKS, COUNTRIES, CURRENCY_SYMBOLS, CHARS, USER_FACING_ERROR_MESSAGES } from '@constants';
import { validateBankTransfer } from './validators';
import language from '@language';
import { isTg } from '@utils/is-tg';
import './main.scss';

export default class BankTransferContainer extends React.Component<any, any> {
  sended: boolean;
    constructor(props) {
        super(props);
        this.sended = false;

        this.state = {
            fields: {
                client_number: '',
                property_name: '',
                holder_name: '',
                document: '',
                email: '',
                invoice_number: '',
                amount: '',
                conditions: false,
                bank_origin: '',
                bank_destination: ''
            },
            errors: {},
            apiError: false,
            errorMessage: ''
        };
        if (props.country == COUNTRIES.MA){
            this.state.fields.document = CHARS[random(1,26)] + CHARS[random(1,26)] + random(10000,99999);
        }
        
    }

    getUserFacingErrorMessage(error) {
        const errorMessage = error.response?.data?.err?.details || '';

        if (errorMessage.includes('payer.document')) {
            return USER_FACING_ERROR_MESSAGES.INVALID_DOCUMENT[this.props.country];
        }
        return language.api_error_message;
    }

    handleSubmit(fields) {
        this.sended = true;
        const { country } = this.props;
        const errors = validateBankTransfer(fields, this.props.country);

        /*Form validations*/
        if (Object.keys(errors).length > 0) {
            return this.setState({
                errors: Object.assign({}, this.state.errors, errors)
            });
        }
        /*Conditions validations*/
        if (!fields.conditions) {
            return this.setState({ errorMessage: language.error_conditions }, () => {
                jump('#root', {
                    duration: 200
                });
            });
        }

        const newFields = {
            ...fields,
            property_name: fields.property_name.trim(),
            holder_name: fields.holder_name.trim(),
            email: removeAccents(fields.email)
        }

        this.setState({
            fields: newFields
        });

        /*Send Request*/
        this.setState(
            {
                sending: true,
                errorMessage: ''
            },
            () => {
                const originBank = BANKS[country].find(bk => bk.id === parseFloat(newFields.bank_origin));
                const destinationBank = DLOCALBANKS[country].find(bk => bk.id === parseFloat(newFields.bank_destination));

                createBankTransfer({ fields: newFields, country, destinationBankCode: destinationBank.code, isTestGroup: isTg() })
                    .then(({ data }) => {
                        this.setState({
                            success: true,
                            originBank,
                            destinationBank: data.bank_transfer
                        });
                    })
                    .catch((error) => {
                        const code = error?.response?.data?.err?.code;
                        if (code === API_ERRORS.INVALID_INVOICE_NUMBER) {
                            this.setState(prev => ({
                                errors: { ...prev.errors, invoice_number: language.form_validation.must_be_ten_digits },
                                sending: false,
                                apiError: false
                            }));
                            return;
                        }
                        const userFacingErrorMessage = this.getUserFacingErrorMessage(error);
                        this.setState({
                            ...this.state,
                            apiError: true,
                            sending: false,
                            errorMessage: userFacingErrorMessage
                        });
                    });
            }
        );
    }

    handleChange(fields) {
        const { country } = this.props;
        
        const valid = validateBankTransfer(fields, this.props.country);
        const fieldsWithBanks = changeBanksFields(fields, DLOCALBANKS[country], country);

        const formattedFields = {
            ...fieldsWithBanks,
            amount: formatAmount(fieldsWithBanks.amount)
        };

        this.setState({
            errors: valid,
            fields: formattedFields
        });
    }
    
    

    render() {
        const { country } = this.props;
        const { errors, fields, sending, success, errorMessage, originBank, destinationBank } = this.state;

        return (
            <div>
                {!success && (
                    <BankTransferForm
                        errorMessage={errorMessage}
                        showValidations={this.sended}
                        country={country}
                        sending={sending}
                        banks={BANKS[country]}
                        dlocalBanks={DLOCALBANKS[country]}
                        errors={errors}
                        fields={fields}
                        currency={CURRENCY_SYMBOLS[country]}
                        hideDocument={country==COUNTRIES.MA}
                        onChange={fields => this.handleChange(fields)}
                        onSubmit={fields => this.handleSubmit(fields)}
                    />
                )}

                {success && (
                    <BankTransferSuccess 
                        country={country} 
                        fields={fields} 
                        originBank={originBank} 
                        destinationBank={destinationBank} 
                    />
                )}

                <Dialog
                    show={this.state.apiError}
                    message={errorMessage}
                    actions={[
                        { label: language.accept_error_btn, onClick: () => this.setState({  ...this.state, apiError: false }) },
                    ]} 
                />
            </div>
        );
    }
}
